module.exports = __webpack_public_path__ + "img/image4.37d10b0d.png";